import { render, staticRenderFns } from "./ProviderPortalSidebar.vue?vue&type=template&id=e60c4f40&scoped=true&"
import script from "./ProviderPortalSidebar.vue?vue&type=script&lang=js&"
export * from "./ProviderPortalSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProviderPortalSidebar.vue?vue&type=style&index=0&id=e60c4f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60c4f40",
  null
  
)

export default component.exports